import { COVID_VACCINE_PROCEDURE_IDS } from '../constants';
import bookingStateSelector from '../selectors/BookingStateSelector';

export function isVaccineProcedure(procedureId) {
    return COVID_VACCINE_PROCEDURE_IDS.includes(String(procedureId));
}

export function isBookingStateForCovidVaccine(state) {
    const bookingState = bookingStateSelector(state);
    return isVaccineProcedure(bookingState?.visit_reason);
}
